module.exports = __webpack_public_path__ + "static/media/icon-social-follower-growth.b051dcc6.svg";